import React from 'react';

import { format } from 'date-fns';

import { Modal } from '@/components/Modal';
import { Account } from '@/core/api/collections/currentAccount';

type Props = {
  account: Account;
  onClose: () => void;
  onSubmit: () => void;
  open: boolean;
  rate?: number;
};

const UserInviteConfirmModal = (props: Props) => {
  const { account, onClose, onSubmit, open, rate } = props;

  if (!account.paymentDate || !account.billingInterval || !rate) {
    return null;
  }

  const newRate = (rate / 100).toFixed(2);
  let paymentDate = new Date(account.paymentDate);
  const dateStr = format(paymentDate, 'MM-dd-yyyy');

  return (
    <Modal
      className="px-16 py-11"
      onClose={onClose}
      open={open}
      noCloseButton={true}
      style={{ width: 525 }}
    >
      <div>
        <h1 className="mb-4 text-xl font-bold text-gray-900">Update Billing</h1>
        <div className="mb-6">
          <p className="text-base text-gray-800">
          Based on the license you selected, your new {account.billingInterval} rate will be ${newRate} (next payment of {dateStr}).
          </p>
        </div>
        <div className="flex justify-center">
          <button className="w-40 h-12 mr-6 text-gray-600 bg-gray-100 rounded" onClick={onClose}>Cancel</button>
          <button className="w-40 h-12 text-gray-100 bg-blue-900 rounded" onClick={onSubmit}>Confirm</button>
        </div>
      </div>
    </Modal>
  );
};

export default UserInviteConfirmModal;
